@use '../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.borderbackground {
  background: linear-gradient(180deg, #4a8fe7 0%, rgba(67, 52, 25, 0) 50%);
}

.subdivbackground {
  background: var(--navigation-heading-menu-hover-bg);
}

.submenu-popup {
  position: absolute;
  top: 3.5rem;
  left: 7.5rem;
  z-index: 10;
  // width: 42rem;
  width: max-content;
  padding: 1.25rem 0.75rem;
  border-radius: 28px;
  transition: left 0.2s ease;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); // drop-shadow-lg
  backdrop-filter: blur(10px);
  background-color: var(--navigation-heading-popup-bg, #0f326acc);
  border-top: 1px solid var(--navigation-menu-border-gradient-start, #1d85fe);
}
